module.exports = __webpack_public_path__ + "static/company_logo03-cf2a595cb6958bf09d80a102c6eba733.png";